
import React from 'react';
import styles from './SignInButton.module.css';
import { Link } from 'react-router-dom';

const SignInButton = () => {
    return (
        <Link to="/signin" style={{ textDecoration: 'none' }}>
            <button className={styles.container}>
                サインイン
            </button>
        </Link>
    );
};

export default SignInButton;
